export default __webpack_public_path__ + "static/24_33-c8b8d4721d2953c275a6dc55fabf8d87.png";